import React from 'react';
import './SelectableCircle.css';

const SelectableCircle = ({ selected, onPress, size = 18, color = '#000' }) => {
  return (
    <button
      className={`selectable-circle ${selected ? 'selected' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onPress();
      }}
      style={{
        width: size,
        height: size,
        '--circle-color': color,
        '--circle-size': size
      }}
    >
      {selected && <div className="selectable-circle-inner" />}
    </button>
  );
};

export default SelectableCircle;
